export default "__VITE_ASSET__7gG6h03C__"